import React from 'react';
import {CloseStopsComponent} from '../../../clean-components/close-stops/close-stops.component';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';

export const CloseStopsDesktop = () => {
    return <DesktopPage>
        <CloseStopsComponent/>
    </DesktopPage>;
};
